import { useQuery } from "@tanstack/react-query";
import { TaskResponse } from "../types/TaskTypes";
import { agentApi } from "../../../api/agent-api";

export const useGetTaskByIdQuery = (taskId: string) => {
  const getTaskByIdQuery = useQuery({
    queryKey: ["get-task-by-id", taskId],
    queryFn: async () => {
      return agentApi.get<TaskResponse>(`/api/v1/tasks/${taskId}`);
    },
  });

  return { getTaskByIdQuery };
};
